module.exports = __webpack_public_path__ + "static/media/nickbos.c34130a3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/nickbos.webp
// module id = 682
// module chunks = 0